import React, { useRef } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BusinessProfile from './components/BusinessProfile';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BusinessProfile />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;